var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("CardContainer", {
    scopedSlots: _vm._u(
      [
        {
          key: "content",
          fn: function () {
            return [
              _c("EmployeeCardAvatar", {
                staticClass: "mb-3",
                attrs: {
                  avatar: _vm.avatar,
                  givenName: _vm.givenName,
                  userUpdatedDate: _vm.userUpdatedDate,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "info",
                      fn: function () {
                        return [_vm._t("avatarInfo")]
                      },
                      proxy: true,
                    },
                    {
                      key: "primary",
                      fn: function () {
                        return [_vm._t("avatarPrimary")]
                      },
                      proxy: true,
                    },
                    {
                      key: "secondary",
                      fn: function () {
                        return [_vm._t("avatarSecondary")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c(
                "ContainerSize",
                {
                  staticClass: "mb-4",
                  attrs: { minHeight: _vm.nameBlockMinHeightValue },
                  on: {
                    "update:minHeight": function ($event) {
                      _vm.nameBlockMinHeightValue = $event
                    },
                    "update:min-height": function ($event) {
                      _vm.nameBlockMinHeightValue = $event
                    },
                  },
                },
                [
                  _vm._t(
                    "nameBlock",
                    function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "flex items-center" },
                          [
                            _c("StatusChip", {
                              staticClass: "mr-2",
                              attrs: { status: _vm.status },
                            }),
                            _c("EmployeeCardUserName", {
                              attrs: {
                                employeePageRouteParams:
                                  _vm.employeePageRouteParams,
                                givenName: _vm.givenName,
                                familyName: _vm.familyName,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    {
                      status: _vm.status,
                      employeePageRouteParams: _vm.employeePageRouteParams,
                    }
                  ),
                ],
                2
              ),
              _vm.$scopedSlots.content
                ? _c(
                    "div",
                    [_vm._t("content", null, { location: _vm.location })],
                    2
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "actions",
          fn: function () {
            return [
              _vm._t("startActions"),
              _c("UiButton", {
                attrs: {
                  variant: "secondary",
                  id: "viewProfile",
                  buttonText: "View Profile",
                  fullWidth: "",
                },
                on: { click: _vm.openEmployeePage },
              }),
              _c("UiButton", {
                attrs: {
                  variant: "secondary",
                  buttonText: "Send Message",
                  id: "sendMessage",
                  fullWidth: "",
                },
                on: { click: _vm.message },
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }